import React, { useState } from "react";
import {
  CForm,
  CFormInput,
  CFormTextarea,
  CFormCheck,
  CLoadingButton,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CButton,
} from "@coreui/react-pro";

/**
 * Modal component for creating/updating App Releases
 * @param {{
 *  lang: string,
 *  State: object,
 *  formVal: object,
 *  handleChangeInput: function,
 *  handleCloseModal: function,
 *  handleSubmit: function
 * }} props
 */
const AppReleaseModal = ({
  lang = "en",
  State,
  formVal,
  handleChangeInput,
  handleCloseModal,
  handleSubmit,
}) => {
  const [errors, setErrors] = useState({});

  const validate = () => {
    const err = {};
    if (!formVal.name?.trim()) {
      err.name = lang === "en" ? "Name is required" : "名称为必填项";
    }
    if (!formVal.description?.trim()) {
      err.description =
        lang === "en" ? "Description is required" : "描述为必填项";
    }
    setErrors(err);
    return Object.keys(err).length === 0;
  };

  const handleFormSubmit = () => {
    if (validate()) {
      handleSubmit();
    }
  };

  return (
    <CModal
      alignment="center"
      visible={State.visible}
      onClosePrevented={handleCloseModal}
    >
      <CModalHeader>
        <CModalTitle>{State.Modeltitel}</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CForm>
          {/* Name Field */}
          <div className="mb-3">
            <CFormInput
              type="text"
              label={lang === "en" ? "Name*" : "名称*"}
              placeholder={"(e.g - v1.0.0)"}
              name="name"
              value={formVal.name}
              onChange={handleChangeInput}
              invalid={!!errors.name}
              feedback={errors.name}
            />
          </div>

          {/* Description Field */}
          <div className="mb-3">
            <CFormTextarea
              label={lang === "en" ? "Description*" : "描述*"}
              placeholder={
                lang === "en" ? "Enter description..." : "请输入描述..."
              }
              name="description"
              value={formVal.description}
              onChange={handleChangeInput}
              rows={3}
              invalid={!!errors.description}
              feedback={errors.description}
            />
          </div>

          {/* Radio: Breaking Changes */}
          <div className="mb-3">
            <label className="form-label d-block">
              {lang === "en" ? "Has Breaking Changes?" : "是否有重大更改？"}
            </label>
            <CFormCheck
              inline
              type="radio"
              label={lang === "en" ? "Yes" : "是"}
              name="hasBreakingChanges"
              value="yes"
              checked={formVal.hasBreakingChanges === "yes"}
              onChange={handleChangeInput}
            />
            <CFormCheck
              inline
              type="radio"
              label={lang === "en" ? "No" : "否"}
              name="hasBreakingChanges"
              value="no"
              checked={formVal.hasBreakingChanges === "no"}
              onChange={handleChangeInput}
            />
          </div>
        </CForm>
      </CModalBody>
      <CModalFooter>
        <CButton color="secondary" onClick={handleCloseModal}>
          {lang === "en" ? "Close" : "关闭"}
        </CButton>
        {State.loading ? (
          <CLoadingButton color="primary" disabled />
        ) : (
          <CButton color="primary" onClick={handleFormSubmit}>
            {State.ModelButton}
          </CButton>
        )}
      </CModalFooter>
    </CModal>
  );
};

export default AppReleaseModal;
